<template>
  <v-row style="margin-top: -120px">
    
    <v-col sm="12" lg="12" md="12" xs="12" style="min-height: 700px">
      <bar-chart width="100%" key="agency-report" report="aclreport_payoutagencies" :chart-params="chartParams" :table-params="tableParams" style="min-height: 500px" :filters="filters" @row-clicked="openReceipt" />
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const transactionsNamespace = createNamespacedHelpers("transaction");
const usersNamespace = createNamespacedHelpers("users");

const BarChart = () => import("@/components/charts/bar/chart.vue");

export default {
  components: {
    BarChart,
  },
  computed: {
    ...transactionsNamespace.mapState({
      transactionType: (state) => state.transactionType,
    }),
    ...usersNamespace.mapState({
      wallet: (state) => state.wallet,
    }),
  },
  data() {
    return {
      drawer: null,
      /* type: "DEFAULT", */
      filters: [
        {
          source: "acl_payoutcompanies",
          itemText: "name",
          itemValue: "code",
          label: "Select Agency",
          column: "company",
          value: null,
          list: [],
        },
         {
          source: "acl_currencies",
          itemText: "name",
          itemValue: "code",
          label: "Select Currency",
          column: "from_currency_code",
          value: null,
          list: [],
       
        },
        {
          type: "combobox",
          source: "acl_users",
          itemText: "fullname",
          itemValue: "code",
          label: "Select User",
          column: "f_user_code",
          value: null,
          list: [],
       
        }
      ],
      chartParams: {
        title: "Pay Out Report",
        x: "x",
        valueColumn: "to_amount",
        labelColumn: "company_name",
          conditions: {
          delivery_type: "COLLECTION",
        },
        valueColumns: [
          { value: "to_amount", text: "Total Pay Out", currencyKey: "to_currency_code" },
          { value: "from_amount", text: "Total Sent", currencyKey: "from_currency_code" },
          { value: "payout_fee", text: "Total Pay Out Fee", currencyKey: "to_currency_code" },
          { value: "total_count", text: "Number Of Payouts" },
        ]
      },
      tableParams: {
        report: "acl_payouts",
        title: "Cashier Outs",
        x: "x",
        valueColumn: "to_amount",
        labelColumn: "cashier_name",
         conditions: {
          delivery_type: "COLLECTION",
        },
        valueColumns: [
          { value: "company_name", text: "Agency", currencyKey: "to_currency_code" },
          { value: "branch_name", text: "Branch", currencyKey: "to_currency_code" },
          { value: "withdrawal_code", text: "Code" },
          { value: "payout_user_fullname", text: "Cashier", currencyKey: "to_currency_code" },
          { value: "withdrawal_code", text:"Code", currencyKey: "to_currency_code"},
          { value: "sender", text: "Sender", currencyKey: "to_currency_code" },
          { field: "sender_mobile_number", label: "Sender Mobile", currencyKey: "to_currency_code" },
          { value: "recipient", text: "Recipient", currencyKey: "to_currency_code" },
          { value: "recipient_mobile_number", text: "Recipient Mobile", currencyKey: "to_currency_code" },
          { value: "payout_at", text: "Date", currencyKey: "to_currency_code" },
          { value: "to_amount", text: "Total Pay Out", currencyKey: "to_currency_code" },
          { value: "payout_fee", text: "Total Pay Out Fee", currencyKey: "to_currency_code" },
        ],
        exportColumns: [
          { field: "company_name", label: "Agency", currencyKey: "to_currency_code" },
          { field: "branch_name", label: "Branch", currencyKey: "to_currency_code" },
          { field: "withdrawal_code", label: "Code" },
          { field: "payout_user_fullname", label: "Cashier", currencyKey: "to_currency_code" },
          { field: "sender", label: "Sender", currencyKey: "to_currency_code" },
          { field: "sender_mobile_number", label: "Sender Mobile", currencyKey: "to_currency_code" },
          { field: "recipient", label: "Recipient", currencyKey: "to_currency_code" },
          { field: "recipient_mobile_number", label: "Recipient Mobile", currencyKey: "to_currency_code" },
          { field: "payout_at", label: "Date", currencyKey: "to_currency_code" },
          { field: "to_amount", label: "Total Pay Out", currencyKey: "to_currency_code" },
          { field: "payout_fee", label: "Total Pay Out Fee", currencyKey: "to_currency_code" },
        ]
      },
    };
  },
  methods: {
    ...usersNamespace.mapActions(["aGetWalletList"]),
    ...transactionsNamespace.mapActions(["aLoadTransactionDetails"]),
    ...transactionsNamespace.mapMutations(["mSetTransactionType"]),
    openReceipt(item) {
      // console.log("item", item);
      this.$router.push({ name: 'send-money-payout-details', params: { secret: item.secret } })
    }
  },
  beforeMount() {
    this.mSetTransactionType(this.type);
  },
  mounted() {
    // this.aGetWalletList();
    
    console.log("type", this.transactionType);
  },
};
</script>